import { ComponentPropsWithoutRef, ForwardedRef, forwardRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@givebutter/primitives/button';
import { maskWholeNumber, pluralize } from '@givebutter/util';
import { useCurrentLetter } from 'assets/js/pages/engage/letters/useCurrentLetter';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { twMerge } from 'tailwind-merge';

interface RecipientCountButtonProps
    extends Omit<ComponentPropsWithoutRef<'button'>, 'children' | 'color'> {
    noExcluded?: boolean;
}

const RecipientCountButton = forwardRef(
    (props: RecipientCountButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
        const { className = '', noExcluded = false, ...rest } = props;
        const { accountId } = useCurrentAccount();
        const history = useHistory();
        const { data: letter } = useCurrentLetter();

        if (!letter) {
            return null;
        }

        return (
            <Button
                ref={ref}
                variant="none"
                color="primary"
                size="sm"
                className={twMerge('font-medium', className)}
                onClick={() =>
                    history.push(
                        `/accounts/${accountId}/engage/letters/draft/${letter.id}/edit/filters`,
                    )
                }
                {...rest}
            >
                {maskWholeNumber(letter.recipient_count)}{' '}
                {pluralize(letter.recipient_count, 'contact')}
                {!noExcluded && (
                    <>
                        {letter.recipient_excluded_count !== 0 && (
                            <span className={'font-normal text-gray-500'}>
                                ({maskWholeNumber(letter.recipient_excluded_count)} excluded)
                            </span>
                        )}
                    </>
                )}
            </Button>
        );
    },
);

export { RecipientCountButton };
export type { RecipientCountButtonProps };
